<template>
  <a-card :bordered="false">
    <h1 slot="title">校园广场</h1>
    <a-row type="flex" :gutter="[24, 24]">
      <a-col v-for="(item, index) in departList" :key="index" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <a-card class="depart-card">
          <div class="depart-cover">
            <a @click="toDetail(item.id)" target="_blank" class="img-zoom">
              <img v-if="item.departCover" :src="item.departCover_url" />
              <img v-else src="@/assets/icon/school.png" alt="" />
            </a>
          </div>
          <h2 class="depart-name" @click="toDetail(item.id)">
            {{ item.departName }}
          </h2>
        </a-card>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import Vue from "vue";
import "@/assets/less/animation.css";
import { getAction } from "@/api/manage";
export default {
  name: "SchoolList",
  data() {
    return {
      departList: [],
    };
  },
  created() {
    this.getDepartList();
  },
  methods: {
    getDepartList() {
      getAction("/sys/sysDepart/publicDepart").then((res) => {
        if (res.success) {
          this.departList = res.result;
        }
      });
    },
    toDetail(id) {
      this.$router.push("/school/detail?id=" + id);
    },
  },
};
</script>

<style lang="less" scoped>
.depart-card {
  border: none;

  /deep/.ant-card-body {
    //width: 350px;
    //height: 280px;
    padding: 0;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: grey 2px 2px 5px;
  }
  .ant-divider-horizontal {
    margin: 12px 0;
  }
  .depart-cover {
    width: 100%;
    height: 220px;
    overflow: hidden;
    img {
      display: block;
      max-width: 100%;
      margin: auto;
    }
  }
  .depart-name {
    cursor: pointer;
    color: #3a3a3a;
    margin-left: 10px;
    padding-top: 10px;
    font: normal normal normal 25px Source Han Sans CN;
  }
}
</style>